// import orchestrators to react to actions triggered when a file provider is added or removed
import './orchestrators/fileProviderAdded';
import './orchestrators/fileProviderRemoved';

//import orchestrators to react to actions regarding search
import './orchestrators/search/startSearch';
import './orchestrators/search/exitSearch';
import './orchestrators/search/clearSearchBox';

export { default as actionsPanel } from './actionsPanel';
export { default as LocalComputerFilePicker } from './components/LocalComputerFilePicker';
export { default as filePicker } from './filePicker';
export { default as preloadFilePicker } from './actions/preloadFilePicker';
export {
    default as createFileProviderItemsViewState,
} from './utils/createFileProviderItemsViewState';
export {
    default as getFileProviderItems,
} from './utils/getOrSearchFileProviderItems/getFileProviderItems';
export {
    default as getUserPreferredFilePickerAction,
} from './utils/getUserPreferredFilePickerAction';
